





















































































import NumDataDisplay from './NumDataDisplay.vue';
import NumDataDisplayWithLabel from './NumDataDisplayWithLabel.vue';
import Characteristic from './Characteristic.vue';
import ChartLabelError from '../ChartGroup/Chart/ChartLabelError.vue';
import Vue from 'vue';
import VueComponent from 'vue';

export default Vue.extend({
  props: {
    isLabelset: {
      type: Boolean,
      default: false,
    },
    datasetType: {
      type: String,
      default: '',
    },
  },
  components: {
    NumDataDisplay,
    NumDataDisplayWithLabel,
    Characteristic,
    ChartLabelError,
  },
  data(): {
    selectedCharacteristic: string;
    isLabelPropSelected: boolean;
    selectBoxLabel: string;
  } {
    return {
      selectedCharacteristic: '',
      isLabelPropSelected: false,
      selectBoxLabel: '',
    };
  },
  computed: {
    badDataNumber() {
      return this.$store.getters.badDataNumber;
    },
    badLabelNumber() {
      return this.$store.getters.schemaAnalysisResult.badLabelNumber;
    },
    totalDataNumber() {
      return this.$store.getters.totalDataNumber;
    },
    totalLabelNumber() {
      return this.$store.getters.schemaAnalysisResult.totalLabelNumber;
    },
    characteristicTitleList(): {
      characteristic: string;
      isLabelProp: boolean;
    }[] {
      let characteristics = [];
      if (this.datasetType === 'text') {
        characteristics = [
          { characteristic: '문장별 길이', isLabelProp: false },
          { characteristic: '문장별 단어', isLabelProp: false },
          { characteristic: '단어별 길이', isLabelProp: false },
        ];
      } else if (this.datasetType === 'audio') {
        characteristics = [
          { characteristic: '길이 분포', isLabelProp: false },
          { characteristic: '샘플링 레이트', isLabelProp: false },
          { characteristic: '파일크기 분포', isLabelProp: false },
        ];
      } else {
        characteristics = [
          { characteristic: '손상 파일 개수', isLabelProp: false },
          { characteristic: '해상도 분포', isLabelProp: false },
          { characteristic: '파일크기 분포', isLabelProp: false },
        ];
      }

      if (this.isLabelset) {
        let propList = [];
        for (const prop in this.$store.getters.labelAnalysisResult) {
          propList.push({ characteristic: prop, isLabelProp: true });
        }

        /** 오류가 많은 순서대로 소팅, 미래의 이지훈이 리펙토링 할 예정 */
        const labelAnalysis = this.$store.getters.labelAnalysisResult;
        const schemaAnalysis =
          this.$store.getters.schemaAnalysisResult.violationPerProp;

        if (!schemaAnalysis) return characteristics;
        propList = propList.sort((A, B) => {
          const propA = A.characteristic;
          const propB = B.characteristic;
          let missingValueA = labelAnalysis[propA].missing_value;
          let missingValueB = labelAnalysis[propB].missing_value;
          let syntaxErrorA = 0;
          let syntaxErrorB = 0;

          const schemaKeyA = '/' + propA.replaceAll('.', '/');
          const schemaKeyB = '/' + propB.replaceAll('.', '/');
          if (schemaAnalysis[schemaKeyA]) {
            syntaxErrorA = schemaAnalysis[schemaKeyA].count;
          }
          if (schemaAnalysis[schemaKeyB]) {
            syntaxErrorB = schemaAnalysis[schemaKeyB].count;
          }

          const totalA = missingValueA + syntaxErrorA;
          const totalB = missingValueB + syntaxErrorB;

          return totalB - totalA;
        });

        /** 상위 3개만 출력 */
        characteristics = characteristics.concat(propList.slice(0, 3));
      } else {
        characteristics.push({
          characteristic: '라벨링 데이터를 추가해 더 많은 분석',
          isLabelProp: false,
        });
      }

      return characteristics;
    },
    errorPercentage(): number {
      const labelAnalysis = this.$store.getters.labelAnalysisResult;
      const schemaAnalysis =
        this.$store.getters.schemaAnalysisResult.violationPerProp;
      const prop = this.selectedCharacteristic;

      if (labelAnalysis[prop]) {
        let normalCount = labelAnalysis[prop].count;
        let missingValue = labelAnalysis[prop].missing_value;
        let syntaxError = 0;

        const schemaKey = '/' + prop.replaceAll('.', '/');
        if (schemaAnalysis[schemaKey]) {
          syntaxError = schemaAnalysis[schemaKey].count;
        }

        let totalError = missingValue + syntaxError;

        return Math.ceil((totalError / normalCount) * 100) / 1;
      } else {
        return NaN;
      }
    },
  },
  methods: {
    onClickCharacteristic(
      characteristicTitle: string,
      isLabelProp: boolean,
    ): void {
      let updatedSelectedCharacteristic = '';

      if (this.selectedCharacteristic === characteristicTitle) {
        updatedSelectedCharacteristic = '';
      } else {
        updatedSelectedCharacteristic = characteristicTitle;
      }
      this.selectedCharacteristic = updatedSelectedCharacteristic;
      this.isLabelPropSelected = isLabelProp;

      this.$emit(
        'onUpdateSelectedCharacteristic',
        updatedSelectedCharacteristic,
        this.isLabelPropSelected,
      );

      (this.$refs.characteristic as VueComponent[]).forEach(
        (v: VueComponent): void => {
          if (
            (v.$el as HTMLElement).innerText === updatedSelectedCharacteristic
          ) {
            v.$el.classList.add('selected');
          } else {
            v.$el.classList.remove('selected');
          }
          return;
        },
      );
    },
  },
});
